import { AxiosError } from 'axios'
import { toast } from 'sonner'

import { ApiError } from '@/services/api/client'

export function parseApiError(error: unknown): ApiError {
  if (error instanceof ApiError) {
    return error
  }

  if (error instanceof AxiosError) {
    return ApiError.fromAxiosError(error)
  }

  return new ApiError(
    'server-error',
    'Server Error',
    500,
    'An unexpected error occurred'
  )
}

export function handleApiError(error: unknown): void {
  const apiError = parseApiError(error)
  // Forbidden responses drive the UI (hidden actions, redirects); they are never shown to the user
  if (apiError.status === 403) return
  toast.error(apiError.title, {
    description: apiError.detail,
    duration: 6000,
  })
}

export function getErrorMessage(error: unknown, defaultMessage: string): string {
  try {
    const apiError = parseApiError(error)
    return (apiError.status !== 403 && apiError.detail) || defaultMessage
  } catch {
    return defaultMessage
  }
}

export function isValidationError(error: unknown): boolean {
  const apiError = parseApiError(error)
  return apiError.status === 422
}

export function getFieldError(
  error: unknown,
  fieldName: string
): string | undefined {
  if (!isValidationError(error)) return undefined

  const apiError = parseApiError(error)
  return apiError.errors?.[fieldName]?.[0]
}